import { render, staticRenderFns } from "./ChangeTel.vue?vue&type=template&id=84d7ff94&"
import script from "./ChangeTel.vue?vue&type=script&lang=js&"
export * from "./ChangeTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports